var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "form",
    staticClass: "event-location insicht insicht--fade-up",
    attrs: { tag: "form", novalidate: "" },
    on: {
      submit: function($event) {
        $event.preventDefault()
        return _vm.onSubmit.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "formbody--narrow" }, [
              _c("h1", {
                staticClass: "event-location__title",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("eventlocation.mainTitle"))
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "event-location__text",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("eventlocation.mainText"))
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "formbody--narrow" },
              [
                _vm.formResponse.message
                  ? _c("GeneralMessage", {
                      ref: "message",
                      attrs: {
                        message: _vm.formResponse.message,
                        type: _vm.formResponse.type
                      },
                      on: {
                        close: function($event) {
                          _vm.formResponse.message = ""
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.fieldSections.length > 1
              ? _c("div", { ref: "progress", staticClass: "form-progress" }, [
                  _c(
                    "div",
                    { staticClass: "form-progress__container--narrow" },
                    [
                      _c("progress", {
                        staticClass: "form-progress__bar",
                        attrs: { max: _vm.fieldSections.length },
                        domProps: { value: _vm.currentSection + 1 }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.fieldSections, function(section, i) {
              return [
                _vm.currentSection >= i
                  ? _c(
                      "section",
                      {
                        key: i,
                        ref: "section",
                        refInFor: true,
                        staticClass: "form-section"
                      },
                      [
                        _c("div", { staticClass: "formbody--narrow" }, [
                          section.title
                            ? _c("h2", {
                                directives: [
                                  {
                                    name: "sanitize",
                                    rawName: "v-sanitize",
                                    value: section.title,
                                    expression: "section.title"
                                  }
                                ],
                                staticClass: "form-section__title"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          section.text
                            ? _c("div", {
                                directives: [
                                  {
                                    name: "sanitize",
                                    rawName: "v-sanitize",
                                    value: section.text,
                                    expression: "section.text"
                                  }
                                ],
                                staticClass: "form-section__text"
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        section.name === "date"
                          ? [
                              _c(
                                "div",
                                { staticClass: "formbody--slim" },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "eventType",
                                      rules: "",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t(
                                          "forms.errors.fieldEmpty"
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInput", {
                                                attrs: {
                                                  type: "text",
                                                  placeholder: _vm.$t(
                                                    "eventlocation.eventTypeLabel"
                                                  ),
                                                  label: _vm.$t(
                                                    "eventlocation.eventTypeLabel"
                                                  ),
                                                  labelOption: _vm.$t(
                                                    "forms.labels.optional"
                                                  ),
                                                  name: "eventType",
                                                  error: errors.length > 0,
                                                  disabled: _vm.formLocked
                                                },
                                                model: {
                                                  value: _vm.formData.eventType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "eventType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.eventType"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "additional-info",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "eventlocation.eventTypeHint"
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "startDate",
                                      rules: "required",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t("forms.errors.date")
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInputDate", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "eventlocation.dateLabel"
                                                  ),
                                                  label: _vm.$t(
                                                    "eventlocation.dateLabel"
                                                  ),
                                                  name: "startDate",
                                                  initialValue:
                                                    _vm.formData.startDate,
                                                  "min-date": "tomorrow",
                                                  required: "",
                                                  disabled: _vm.formLocked
                                                },
                                                model: {
                                                  value: _vm.formData.startDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "startDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.startDate"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "time",
                                      rules: "required",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t("forms.errors.date")
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("TimePicker", {
                                                attrs: {
                                                  times: _vm.timeOptions,
                                                  label: _vm.$t(
                                                    "forms.labels.time"
                                                  ),
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.formData.time,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "time",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.time"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "participants",
                                      rules: "required",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t(
                                          "forms.errors.fieldEmpty"
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInputRange", {
                                                attrs: {
                                                  prefix: _vm.$t(
                                                    "eventlocation.participantsLabel"
                                                  ),
                                                  min:
                                                    _vm.locationEnhanced
                                                      .participantsMin || 1,
                                                  max:
                                                    _vm.locationEnhanced
                                                      .participantsMax || 50,
                                                  step: 1,
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.participants,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "participants",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "formData.participants"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "noteDate",
                                      rules: "",
                                      tag: "div",
                                      customMessages: {}
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInputTextarea", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "eventlocation.noteLabelDate"
                                                  ),
                                                  label: _vm.$t(
                                                    "eventlocation.noteLabelDate"
                                                  ),
                                                  labelOption: _vm.$t(
                                                    "forms.labels.optional"
                                                  ),
                                                  name: "noteDate",
                                                  disabled: _vm.formLocked,
                                                  "no-float": ""
                                                },
                                                model: {
                                                  value: _vm.formData.noteDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "noteDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.noteDate"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        section.name === "menu"
                          ? [
                              _vm.coursesEnhanced.length
                                ? _c(
                                    "div",
                                    { staticClass: "formbody--normal" },
                                    _vm._l(_vm.coursesEnhanced, function(
                                      category
                                    ) {
                                      return _c(
                                        "Collapsible",
                                        {
                                          key: category.id,
                                          ref: "courses",
                                          refInFor: true,
                                          staticClass:
                                            "event-location__category",
                                          attrs: { "initial-open": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "trigger",
                                                fn: function(ref) {
                                                  var isOpen = ref.isOpen
                                                  return [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "event-location__category-title"
                                                      },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              category.name
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        !category.optionsRequired
                                                          ? _c("small", {
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  _vm.$t(
                                                                    "forms.labels.optional"
                                                                  )
                                                                )
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors[category.id]
                                                      ? _c("div", {
                                                          staticClass:
                                                            "event-location__category-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.errors[
                                                                category.id
                                                              ]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "event-location__menu"
                                            },
                                            _vm._l(category.options, function(
                                              child
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key: child.uuid,
                                                  staticClass:
                                                    "event-location__menu-item",
                                                  class: {
                                                    "event-location__menu-item--checked":
                                                      _vm.quantities[
                                                        child.uuid
                                                      ] > 0
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "event-location__menu-item-label"
                                                    },
                                                    [
                                                      child.image
                                                        ? _c(
                                                            "figure",
                                                            {
                                                              staticClass:
                                                                "event-location__menu-item-image"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "event-location__menu-item-image-element event-location__menu-item-image-element--wide",
                                                                attrs: {
                                                                  src:
                                                                    child.image,
                                                                  alt:
                                                                    child.name,
                                                                  loading:
                                                                    "lazy"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "event-location__menu-item-content"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "event-location__menu-item-name",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                child.name
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "event-location__menu-item-description",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                child.description
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "event-location__menu-item-price"
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "event-location__menu-item-price-current",
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    _vm.$options.filters.fwgpricecent(
                                                                      child.price,
                                                                      "html"
                                                                    )
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          !category.calculateForAll
                                                            ? _c(
                                                                "QuantityCounter",
                                                                {
                                                                  attrs: {
                                                                    quantity:
                                                                      _vm
                                                                        .quantities[
                                                                        child
                                                                          .uuid
                                                                      ] || 0,
                                                                    "base-class":
                                                                      "event-location__menu-item-quantity",
                                                                    max:
                                                                      _vm
                                                                        .formData
                                                                        .participants,
                                                                    locked:
                                                                      _vm.formLocked,
                                                                    writable: ""
                                                                  },
                                                                  on: {
                                                                    sub: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onSubCourseOption(
                                                                        child,
                                                                        category
                                                                      )
                                                                    },
                                                                    add: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onAddCourseOption(
                                                                        child,
                                                                        category
                                                                      )
                                                                    },
                                                                    update: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onUpdateCourseOption(
                                                                        child,
                                                                        category,
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "event-location__menu-item-selection"
                                                                },
                                                                [
                                                                  _c("Button", {
                                                                    staticClass:
                                                                      "event-location__menu-item-button",
                                                                    attrs: {
                                                                      level: !!_vm
                                                                        .quantities[
                                                                        child
                                                                          .uuid
                                                                      ]
                                                                        ? "primary"
                                                                        : "outline",
                                                                      text: !!_vm
                                                                        .quantities[
                                                                        child
                                                                          .uuid
                                                                      ]
                                                                        ? _vm.$t(
                                                                            "eventlocation.selectedLabel"
                                                                          )
                                                                        : _vm.$t(
                                                                            "eventlocation.selectLabel"
                                                                          ),
                                                                      disabled:
                                                                        _vm.formLocked,
                                                                      block: "",
                                                                      small: ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        $event.preventDefault()
                                                                        return _vm.onSelectCourseOption(
                                                                          child,
                                                                          category
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ],
                                                                1
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "formbody--slim spacing--top-2"
                                },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "noteCourses",
                                      rules: "",
                                      tag: "div",
                                      customMessages: {}
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInputTextarea", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "eventlocation.noteLabelMenu"
                                                  ),
                                                  label: _vm.$t(
                                                    "eventlocation.noteLabelMenu"
                                                  ),
                                                  labelOption: _vm.$t(
                                                    "forms.labels.optional"
                                                  ),
                                                  name: "noteCourses",
                                                  disabled: _vm.formLocked,
                                                  "no-float": ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.noteCourses,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "noteCourses",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.noteCourses"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        section.name === "drinks"
                          ? [
                              _vm.locationEnhanced.drinks
                                ? _c(
                                    "div",
                                    { staticClass: "formbody--normal" },
                                    _vm._l(
                                      _vm.locationEnhanced.drinks,
                                      function(category) {
                                        return _c(
                                          "Collapsible",
                                          {
                                            key: category.id,
                                            staticClass:
                                              "event-location__category",
                                            attrs: { "initial-open": false }
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "trigger" },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "event-location__category-title"
                                                  },
                                                  [
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          category.name
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "event-location__drinks"
                                              },
                                              _vm._l(category.options, function(
                                                item,
                                                index
                                              ) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key:
                                                      category.id + "-" + index,
                                                    staticClass:
                                                      "event-location__drinks-item"
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "event-location__drinks-item-name",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          item.name
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "event-location__drinks-item-price",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.formatDrinkPrice(
                                                            item
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "formbody--slim spacing--top-2"
                                },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "noteDrinks",
                                      rules: "",
                                      tag: "div",
                                      customMessages: {}
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInputTextarea", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "eventlocation.noteLabelDrinks"
                                                  ),
                                                  label: _vm.$t(
                                                    "eventlocation.noteLabelDrinks"
                                                  ),
                                                  labelOption: _vm.$t(
                                                    "forms.labels.optional"
                                                  ),
                                                  name: "noteDrinks",
                                                  disabled: _vm.formLocked,
                                                  "no-float": ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.noteDrinks,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "noteDrinks",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.noteDrinks"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        section.name === "other"
                          ? [
                              _c(
                                "div",
                                { staticClass: "formbody--slim" },
                                [
                                  _c("FormInputCheckboxes", {
                                    staticClass: "event-location__checkboxes",
                                    attrs: {
                                      options: _vm.specialsOptions,
                                      vertical: ""
                                    },
                                    model: {
                                      value: _vm.formData.specials,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formData, "specials", $$v)
                                      },
                                      expression: "formData.specials"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        section.name === "details"
                          ? [
                              _c(
                                "div",
                                { staticClass: "formbody--slim" },
                                [
                                  _c("ValidationObserver", {
                                    staticClass: "input-wrapper",
                                    attrs: { tag: "div" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var validated = ref.validated
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "input-group" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-group__span-6",
                                                    attrs: {
                                                      name: "firstName",
                                                      rules: "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  name:
                                                                    "firstName",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked,
                                                                  required: ""
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.formData
                                                                      .firstName,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.formData,
                                                                      "firstName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "formData.firstName"
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-group__span-6",
                                                    attrs: {
                                                      name: "lastName",
                                                      rules: "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  name:
                                                                    "lastName",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked,
                                                                  required: ""
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.formData
                                                                      .lastName,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.formData,
                                                                      "lastName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "formData.lastName"
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("div", {
                                                    staticClass:
                                                      "input-error input-group__span-12",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.combineErrors(
                                                          errors
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "company",
                                      rules: "",
                                      tag: "div",
                                      customMessages: {}
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInput", {
                                                attrs: {
                                                  type: "text",
                                                  placeholder: _vm.$t(
                                                    "forms.labels.company"
                                                  ),
                                                  label: _vm.$t(
                                                    "forms.labels.company"
                                                  ),
                                                  labelOption: _vm.$t(
                                                    "forms.labels.optional"
                                                  ),
                                                  name: "company",
                                                  disabled: _vm.formLocked
                                                },
                                                model: {
                                                  value: _vm.formData.company,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "company",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.company"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationObserver", {
                                    staticClass: "input-wrapper",
                                    attrs: { tag: "div" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var validated = ref.validated
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "input-group" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-group__span-9",
                                                    attrs: {
                                                      name: "street",
                                                      rules: "",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.street"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.street"
                                                                  ),
                                                                  labelOption: _vm.$t(
                                                                    "forms.labels.optional"
                                                                  ),
                                                                  name:
                                                                    "street",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.formData
                                                                      .street,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.formData,
                                                                      "street",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "formData.street"
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-group__span-3",
                                                    attrs: {
                                                      name: "streetNumber",
                                                      rules: "",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.number"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.number"
                                                                  ),
                                                                  labelOption: _vm.$t(
                                                                    "forms.labels.optional"
                                                                  ),
                                                                  name:
                                                                    "streetNumber",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.formData
                                                                      .streetNumber,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.formData,
                                                                      "streetNumber",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "formData.streetNumber"
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("div", {
                                                    staticClass:
                                                      "input-error input-group__span-12",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.combineErrors(
                                                          errors
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationObserver", {
                                    staticClass: "input-wrapper",
                                    attrs: { tag: "div" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var validated = ref.validated
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "input-group" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-group__span-3",
                                                    attrs: {
                                                      name: "zip",
                                                      rules: "digits:4",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                        digits: _vm.$t(
                                                          "forms.errors.zip"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c("FormInput", {
                                                                ref: "zip",
                                                                refInFor: true,
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.zip"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.zip"
                                                                  ),
                                                                  labelOption: _vm.$t(
                                                                    "forms.labels.optional"
                                                                  ),
                                                                  name: "zip",
                                                                  minlength: 4,
                                                                  maxlength: 4,
                                                                  inputmode:
                                                                    "decimal",
                                                                  pattern:
                                                                    "[0-9]{4}",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked
                                                                },
                                                                on: {
                                                                  keydown:
                                                                    _vm.onZipKeydown,
                                                                  input:
                                                                    _vm.onZipInput
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.formData
                                                                      .postcode,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.formData,
                                                                      "postcode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "formData.postcode"
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-group__span-9",
                                                    attrs: {
                                                      name: "city",
                                                      rules: "",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.city"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.city"
                                                                  ),
                                                                  labelOption: _vm.$t(
                                                                    "forms.labels.optional"
                                                                  ),
                                                                  name: "city",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.formData
                                                                      .city,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.formData,
                                                                      "city",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "formData.city"
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("div", {
                                                    staticClass:
                                                      "input-error input-group__span-12",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.combineErrors(
                                                          errors
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper spacing--top-2",
                                    attrs: {
                                      name: "email",
                                      rules: "required|email",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t(
                                          "forms.errors.fieldEmpty"
                                        ),
                                        email: _vm.$t(
                                          "forms.errors.emailInvalid"
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            var invalid = ref.invalid
                                            var validated = ref.validated
                                            return [
                                              _c("FormInput", {
                                                attrs: {
                                                  type: "email",
                                                  autocomplete: "email",
                                                  placeholder: _vm.$t(
                                                    "forms.labels.email"
                                                  ),
                                                  label: _vm.$t(
                                                    "forms.labels.email"
                                                  ),
                                                  name: "email",
                                                  error: errors.length > 0,
                                                  disabled: _vm.formLocked,
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.formData.email,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.email"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper",
                                    attrs: {
                                      name: "phoneNumber",
                                      rules: "required|phone",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t(
                                          "forms.errors.fieldEmpty"
                                        ),
                                        phone: _vm.$t("forms.errors.phone")
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            var invalid = ref.invalid
                                            var validated = ref.validated
                                            return [
                                              _c("FormInput", {
                                                attrs: {
                                                  type: "tel",
                                                  placeholder: _vm.$t(
                                                    "forms.labels.phone"
                                                  ),
                                                  label: _vm.$t(
                                                    "forms.labels.phone"
                                                  ),
                                                  name: "phoneNumber",
                                                  error: errors.length > 0,
                                                  disabled: _vm.formLocked,
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.phoneNumber,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "phoneNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.phoneNumber"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    staticClass: "input-wrapper spacing--top-2",
                                    attrs: {
                                      name: "noteDetails",
                                      rules: "",
                                      tag: "div",
                                      customMessages: {}
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInputTextarea", {
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "eventlocation.noteLabelDetails"
                                                  ),
                                                  label: _vm.$t(
                                                    "eventlocation.noteLabelDetails"
                                                  ),
                                                  labelOption: _vm.$t(
                                                    "forms.labels.optional"
                                                  ),
                                                  name: "noteDetails",
                                                  disabled: _vm.formLocked,
                                                  "no-float": ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData.noteDetails,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "noteDetails",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.noteDetails"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: {
                                        required: { allowFalse: false }
                                      },
                                      name: "acceptTerms",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t(
                                          "eventlocation.errorTerms"
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c(
                                                "FormInputCheckbox",
                                                {
                                                  attrs: {
                                                    name: "terms",
                                                    value: "acceptTerms",
                                                    required: "",
                                                    immediate: "",
                                                    block: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.acceptTerms,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "acceptTerms",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.acceptTerms"
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "eventlocation.termsLabel"
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: {
                                        required: { allowFalse: false }
                                      },
                                      name: "acceptPrivacy",
                                      tag: "div",
                                      customMessages: {
                                        required: _vm.$t(
                                          "eventlocation.errorPrivacy"
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c(
                                                "FormInputCheckbox",
                                                {
                                                  attrs: {
                                                    name: "terms",
                                                    value: "acceptPrivacy",
                                                    required: "",
                                                    immediate: "",
                                                    block: ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData
                                                        .acceptPrivacy,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "acceptPrivacy",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.acceptPrivacy"
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "eventlocation.privacyLabel"
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "formbody--narrow" },
                  [
                    _vm.fieldSections.length &&
                    _vm.currentSection === i &&
                    _vm.currentSection < _vm.fieldSections.length - 1
                      ? _c("Button", {
                          attrs: {
                            level: "primary",
                            text: _vm.$t("forms.buttons.next"),
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.onNextSection(i)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "formbody--narrow" },
              [
                _vm.currentSection === _vm.fieldSections.length - 1
                  ? _c("Button", {
                      attrs: {
                        level: "primary",
                        text: _vm.$t("forms.buttons.send"),
                        type: "submit"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "event-location__footer" }, [
              _c("div", { staticClass: "event-location__footer-wrapper" }, [
                _c("div", { staticClass: "event-location__footer-details" }, [
                  _c("div", { staticClass: "event-location__footer-item" }, [
                    _c("div", {
                      staticClass: "event-location__footer-item-label",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("eventlocation.locationPriceLabel")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "event-location__footer-item-value",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(
                            _vm.locationPrice,
                            "short"
                          )
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-location__footer-item" }, [
                    _c("div", {
                      staticClass: "event-location__footer-item-label",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("eventlocation.participantsLabel")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "event-location__footer-item-value",
                      domProps: { innerHTML: _vm._s(_vm.formData.participants) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-location__footer-item" }, [
                    _c("div", {
                      staticClass: "event-location__footer-item-label",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("eventlocation.menuPriceLabel")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "event-location__footer-item-value",
                      domProps: {
                        innerHTML: _vm._s(
                          "Ø " +
                            _vm.$options.filters.fwgpricecent(
                              _vm.averageMenuPrice,
                              "short"
                            )
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "event-location__footer-item" }, [
                    _c("div", {
                      staticClass: "event-location__footer-item-label",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("eventlocation.menuTotalLabel")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "event-location__footer-item-value",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(
                            _vm.totalMenuPrice,
                            "short"
                          )
                        )
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "event-location__footer-total" }, [
                  _c("div", { staticClass: "event-location__footer-item" }, [
                    _c("div", {
                      staticClass: "event-location__footer-item-label",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("eventlocation.totalLabel"))
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "event-location__footer-item-value",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(_vm.total, "short")
                        )
                      }
                    })
                  ])
                ])
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }